import { Trans } from "@lingui/react";
import * as React from 'react';
import { Validating as SharedValidating } from '~shared/components/Validation/Validating';
import { H3 } from '~ui/components/typography/Heading/Heading';
import { getHeaderFontSizeInPx } from '~ui/styleGuide/fontStyles';
import { LAYOUT_BREAKPOINTS } from '../../Responsive/client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Loading state while we are waiting for an operation to finish.
 * - Renders message with the speedlo spinner.
 * - Adds sub-label if the validation takes longer than 5s.
 */
export var Validating = function Validating(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_jsx(SharedValidating, {
    message: /*#__PURE__*/_jsx(H3, {
      fontStyle: "boldSemi",
      textAlign: "center",
      responsiveSize: {
        minSize: getHeaderFontSizeInPx("l24"),
        maxSize: getHeaderFontSizeInPx("l28"),
        minBreakpoint: LAYOUT_BREAKPOINTS.smMin,
        maxBreakpoint: LAYOUT_BREAKPOINTS.mdMax
      },
      children: message !== null && message !== void 0 ? message : /*#__PURE__*/_jsx(Trans, {
        id: "y8908V"
      })
    })
  });
};